export default "__VITE_ASSET__cffc7a04__"